// src/utils/api.js
import axios from 'axios'; 
const BASE_URL = 'https://hifiinternationals.com/plan/api';
const api = axios.create({
  baseURL: BASE_URL, 
});
// import { toast } from 'react-toastify';
api.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers['Authorization'] = token;
  return config;
});

// api.interceptors.request.use(config => {
//   if (!config.url.includes("login")) {
//     const token = localStorage.getItem("auth_token");
//     if (token) config.headers.Authorization = token;
//   }
//   return config;
// });


// api.interceptors.response.use(
//   res => {console.log( ' eeee ') , res},
//   err => {
//     if (err.response?.status === 401) localStorage.removeItem('auth_token');
//     return Promise.reject(err);
//   }
// );

// export const getData = (url, params) => api.get(url, { params }); 

export const getData = async(url , params ) => {
  try{
    const response = await api.get(url, {params});
    return response;
  }catch (error){
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      'Something went wrong';

    // Optionally remove token if unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('isAuthenticated')
    }

    // Throw custom error to show in UI
    throw new Error(errorMessage);
  }
}
 
export const postData = async (url, data) => {
  try {
    const response = await api.post(url, data);
    return response;
  } catch (error) {
    console.error('❌ Error:', error);

    // Get server message if available
    const errorMessage =  error?.response?.data?.message ||  error?.response?.data?.error || error?.response?.message ||  'Something went wrong';

    // Optionally remove token if unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
    }

    // Throw custom error to show in UI
    return { data : {success : false , message : errorMessage}}
    // throw new Error(errorMessage);
  }
};


export async function loginUser (data){  
    const res = await fetch(`${BASE_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }); 
    return res.json(); 
}  
 
// export const loginUser = async (walletAddress) => {
//   try {
//     // Use FormData for PHP backend
//     const formData = new FormData();
//     formData.append("wallet_address", walletAddress); // PHP expects this key

//     const res = await api.post("login", formData);
//     return res.data; // expects { success, token, message }
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error?.response?.data?.message ||
//         error?.response?.data?.error ||
//         "Login failed",
//     };
//   }
// };


export default api;
